(function () {
  try {
    const scriptTag = document.currentScript;

    if (scriptTag?.dataset.loggedIn === 'true') {
      const redirect = sessionStorage.getItem('post_register_redirect');
      const ref = document.createElement('a');
      ref.href = document.referrer || '';

      if (redirect && !!ref.pathname && ref.pathname.indexOf('/account/register') === 0) {
        window.location.replace(redirect);
      }
    }
  } catch (err) {
    console.warn('redirect check failed', err);
  } finally {
    if (window.location.pathname.indexOf('/account/register') !== 0) {
      sessionStorage.removeItem('post_register_redirect');
    }
  }
})();
